import { createStyles } from '@mantine/styles';


export default createStyles((theme: {
    colors: { [x: string]: any[] };
    white: string;
    fontSizes: any;
    spacing: any;
    radius: any;
    fn: any;
    colorScheme: any;
}) => ({

    icon: {
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
        marginRight: 6,
    },

    xxsGapGroup: {
        [theme.fn.smallerThan('xs')]: {
            gap: 10,
        },
    },

    features: {
        display: 'inline-flex',
        alignItems: 'center',
        margin: 0,
        marginRight: 20,
        textAlign: 'left',
        fontSize: 16,
        fontWeight: 300,

        [theme.fn.smallerThan('md')]: {
            marginRight: 0,
        },
    },

    textHidden: {
        [theme.fn.smallerThan('xs')]: {
            display: 'none',
        },
    },

    textNumber: {
        marginRight: 4,
    },

}));
